import React from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';

export const Slider = () => {
    const {
        played,
        handleSeekChange,
        handleSeekMouseUp,
        volumeCollapse,
    } = useAudioPlayer();

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                position: 'absolute',
                left: '137px',
                cursor: 'pointer',
            }}
            className="track-slider-container"
        >
            <input
                className={`track-slider${volumeCollapse ? ' collapsed' : ''}`}
                type="range"
                id="track-slider"
                min={0}
                aria-label="Track Progress"
                max={0.999999}
                step="any"
                value={played}
                onChange={handleSeekChange}
                onMouseUp={handleSeekMouseUp}
                onTouchEnd={handleSeekMouseUp}
            />
        </div>
    );
};
